"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOutOfStockQuantity = void 0;
const getOutOfStockQuantity = ({
  outOfStockQuantity,
  outOfStockProducts
}) => {
  let outOfStockItemsCount = outOfStockQuantity ?? 0;
  if (outOfStockQuantity === undefined) {
    outOfStockProducts?.forEach(product => {
      outOfStockItemsCount += product.quantity;
    });
  }
  return outOfStockItemsCount;
};
exports.getOutOfStockQuantity = getOutOfStockQuantity;